import React from 'react';
import PropTypes from 'prop-types';

import { Consumer } from '../context';

class ContentConsumer extends React.Component {
  render() {
    return (
      <Consumer>
        { (props) => this.props.children( { ...props })}
      </Consumer>
    );
  }
};

ContentConsumer.propTypes = {
  children: PropTypes.func.isRequired,
};

export default ContentConsumer;